import { SET_CLIENT_MONITOR_CART_STATE, SET_CLIENT_MONITOR_QR_CODE_PAYMENT_SESSION, SHOW_CLIENT_MONITOR_FINAL_STEP } from '../../actionTypes/clientMonitorCart'

export const setClientMonitorCartState = value => ({ type: SET_CLIENT_MONITOR_CART_STATE, value })

export const showClientMonitorFinalStep = value => ({ type: SHOW_CLIENT_MONITOR_FINAL_STEP, value })

export const setClientMonitorQrCodePaymentSession = value => ({ type: SET_CLIENT_MONITOR_QR_CODE_PAYMENT_SESSION, value })
